import type { FC } from "react";
import { useLocale } from "hooks";
import clsx from "clsx";
import translation from "../translation";
import CategorySelect from "./CategorySelect";
import { useFormContext } from "react-hook-form";

interface IProps {
  activeTab: string;
  handleSearch: (isEmptyInput?: boolean) => Promise<void>;
  data: {
    eventsTagTrees: any[];
    newsTagTrees: any[];
  };
  layout?: "primary" | "secondary";
  parentOptions?: any[];
}

const NewsFilter: FC<IProps> = ({
  activeTab,
  handleSearch,
  data,
  layout = "primary",
  parentOptions,
}) => {
  const { locale, isRTL } = useLocale();
  const { control, register } = useFormContext();

  const handleKeyDown = (ev) => {
    if (ev.key === "Enter") handleSearch(!ev.target.value);
  };

  // const handleChange = (ev) => {
  //   if (!ev.target.value) handleSearch(true);
  // };

  return (
    <div
      className={clsx("tw-my-5 md:tw-my-0 tw-flex tw-flex-col md:tw-flex-row", {
        "tw-col-span-5 md:tw-col-span-4": layout === "secondary",
        "!tw-mt-5 lg:!tw-mt-0 !tw-mb-2.5": layout === "primary",
      })}
    >
      <div
        className={clsx("tw-min-w-[200px]", {
          "md:tw-mr-2": !isRTL,
          "md:tw-ml-2": isRTL,
        })}
      >
        <CategorySelect
          options={
            parentOptions
              ? parentOptions?.findIndex(
                  (item) => item?.value === activeTab
                ) === 0
                ? data?.newsTagTrees
                : data?.eventsTagTrees
              : ["events", "speechs"].includes(activeTab)
              ? data?.eventsTagTrees
              : data?.newsTagTrees
          }
          control={control}
          layout={layout}
        />
      </div>
      <div className="tw-relative tw-w-full md:tw-min-w-[310px] xxxl:tw-min-w-[422px] tw-mt-5 md:tw-mt-0">
        <input
          type="search"
          className={clsx(
            "tw-bg-[#FFFFFF] tw-text-sm tw-text-[#344456]/50 placeholder:tw-text-[#344456]/20 tw-border tw-border-[#344456]/20 focus-visible:!tw-border focus-visible:!tw-border-[#344456]/20 focus-visible:!tw-border-solid tw-font-medium tw-rounded-lg tw-py-2.5 xxxl:tw-py-4 tw-outline-none md:tw-min-w-[300px] xxxl:tw-min-w-[412px] tw-w-full xxxl:tw-text-[17.33px] tw-h-[42px] xxxl:tw-h-[54px]",
            {
              "tw-text-left tw-pl-4 ltr": !isRTL,
              "tw-pr-4": isRTL,
            }
          )}
          placeholder={`${translation[locale]?.SEARCH}...`}
          {...register("search")}
          onKeyDown={handleKeyDown}
          // onChange={(ev) => {
          // handleChange(ev);
          // register("search")?.onChange?.(ev);
          // }}
        />
        <button
          onClick={() => handleSearch()}
          className={clsx(
            "tw-absolute tw-top-1 tw-border-0 tw-cursor-pointer tw-bg-[#004883] hover:tw-bg-[#004883]/80 tw-rounded-md tw-flex tw-items-center tw-justify-center tw-p-2 xxxl:tw-p-3.5",
            { "tw-left-0.5": isRTL, "tw-right-0.5": !isRTL }
          )}
        >
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.9225 15.9108L13.8542 12.8425C14.8817 11.5583 15.5 9.93413 15.5 8.16663C15.5 4.03079 12.135 0.666626 8 0.666626C3.865 0.666626 0.5 4.03079 0.5 8.16663C0.5 12.3025 3.865 15.6666 8 15.6666C9.76833 15.6666 11.3925 15.0483 12.6758 14.0216L15.7442 17.0891L16.9225 15.9108ZM8 14C4.78333 14 2.16667 11.3833 2.16667 8.16663C2.16667 4.95079 4.78333 2.33329 8 2.33329C11.2167 2.33329 13.8333 4.95079 13.8333 8.16663C13.8333 11.3833 11.2167 14 8 14Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default NewsFilter;
